import * as Backbone from "backbone";

export class Install extends Backbone.Model {

    getDisplayName() {
        var orgName = this.get('organization_install_name');
        return orgName ? orgName : this.get('name');
    }

    getDisplayAddress() {
        var addr1 = this.get('property_address');
        var addr2 = this.get('property_address_2');
        var state = this.get('property_address_state');
        var zip = this.get('property_address_zip');

        var rtn = '';
        if (addr1) {
            rtn += addr1;

            if (addr2) rtn += ' ' + addr2;
        }

        if (state) {
            if (rtn) rtn += ', ';
            rtn += state.toUpperCase();

            if (zip) rtn += ' ' + zip;
        }

        return rtn
    }

    getLinkOrg() {
        var orgId = this.get('organization_id');
        return orgId == null ? 0 : orgId
    }

    isVirtual() {
        return this.get('virtual') === 1;
    }
}
Install.prototype.idAttribute = 'joined_id';


// WEBPACK FOOTER //
// ./srv/public/js/models/Install.ts